import axios from 'axios'

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(token) {
  subscribers = subscribers.filter(callback => callback(token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default function setup (vm) {
	axios.interceptors.request.use(function (config) {
		return config
	}, function (err) {
		return Promise.reject(err)
	})
	axios.interceptors.response.use(function (response) {
		return response
	}, function (error) {
		const { config, response: { status, data } } = error
		const originalRequest = config
		if (status === 401 && vm.$store.state.user != null) {
			console.log(error)
			if (!isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true
				axios.post(`${vm.$store.state.serverURI}/api/login/refresh`, null, vm.$store.getters.getHeader).then((response) => {
					let token = response.data.access_token
					vm.$store.commit('SET_TOKEN', token)
					if (window.localStorage) {
						localStorage.setItem('token', token)
					}
					isAlreadyFetchingAccessToken = false
					onAccessTokenFetched(token)
				})
			} else {
				if (data.message.includes('refresh_token')) {
					console.log('Not authenticated')
					isAlreadyFetchingAccessToken = false
					localStorage.setItem('route', error.path)
					vm.logout()
					return Promise.reject(error)
				}
				if (data.message.includes('fora do horário')) {
					console.log('Fora do horário')
					vm.logout()
					return Promise.reject(error)
				}
			}
			const retryOriginalRequest = new Promise((resolve) => {
				addSubscriber(token => {
					originalRequest.headers.Authorization = 'Bearer ' + token
					resolve(axios(originalRequest))
				})
			})
			return retryOriginalRequest
		}
		if (error.response.data instanceof Blob) {
			let erro = error.response.data;
			let blob = new Blob([erro], {type: 'application/json'});
			let reader = new FileReader();
			reader.addEventListener("loadend", function() {
				erro = JSON.parse(reader.result)
				vm.$store.commit('SET_ALERT_MESSAGE', erro.mensagem);
				vm.$store.commit('SET_ALERT_DETAIL', erro.erros);
				vm.$store.commit('SHOW_ALERT_ERROR');
			});
			reader.readAsText(blob);
		} else {
			vm.$store.commit('SET_ALERT_MESSAGE', error.response.data.mensagem);
			vm.$store.commit('SET_ALERT_DETAIL', error.response.data.erros);
			vm.$store.commit('SHOW_ALERT_ERROR');
		}
		return Promise.reject(error)
	})
}




// WEBPACK FOOTER //
// ./src/helpers/interceptors.js